import React, { useState, useEffect } from "react";
import { Helmet } from 'react-helmet';
import axios from "axios";
import { buildApiUrl } from "../utils/api";

function RequestList() {
    const [bookings, setBookings] = useState([]);

    useEffect(() => {
        const fetchUserAndBookings = async () => {
            try {
                const token = localStorage.getItem('token');
                if (token) {
                    const userResponse = await axios.get(buildApiUrl('/api/client/clientDetail'), {
                        headers: { Authorization: `Bearer ${token}` }
                    });

                    if (userResponse.data && userResponse.data.user) {
                        // Fetch bookings based on the user ID decoded from token
                        fetchWarehouseBookings(token);
                    }
                }
            } catch (error) {
                console.error('Error fetching user details', error);
            }
        };

        const fetchWarehouseBookings = async (token) => {
            try {
                const response = await axios.get(buildApiUrl('/api/client/warehouseRequest'), {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setBookings(response.data); // Set fetched bookings
            } catch (error) {
                console.error('Error fetching warehouse bookings', error);
            }
        };

        fetchUserAndBookings();
    }, []);
    return (
        <>
            <Helmet>
                <title>Warehouse Request | 3pl Site</title>
            </Helmet>
            <div className='requestList'>
                <h1>Your Warehouse Requester List</h1>
                {bookings.length > 0 ? (
                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead className="thead-dark">
                                <tr>
                                    <th scope="col">S.no</th>
                                    <th scope="col">Booking ID</th>
                                    <th scope="col">Client Name</th>
                                    <th scope="col">Client E-mail</th>
                                    <th scope="col">Client Contact</th>
                                    <th scope="col">Total SKU</th>
                                    <th scope="col">Avg.Monthly Orders</th>
                                    <th scope="col">Sales Channel</th>
                                    <th scope="col">Booking Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bookings.map((booking, index) => (
                                    <tr key={index}>
                                        <td>{index+1}</td>
                                        <td>{booking._id}</td>
                                        <td>{booking.userName}</td>
                                        <td>{booking.userEmail}</td>
                                        <td>{booking.userPhone}</td>
                                        <td>{booking.totalSKU}</td>
                                        <td>{booking.averageMonthlyOrders}</td>
                                        <td>{booking.salesChannel}</td>
                                        <td>{booking.bookingDate}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <p>No bookings found for your warehouse.</p>
                )}
                <div className="notes text-start">
                    <h3>Note:</h3>
                    <p><b>*</b>Listed Client Details are the Request for your Warehouse.</p>
                    <p><b>*</b>Response to the Team Immediately as soon as Possible.</p>
                </div>
            </div>
        </>
    )
}
export default RequestList
